<script setup lang="ts"></script>

<template>
  <div :class="$style.pageContentWrapper" data-testid="pageContentWrapper">
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/variables';

.pageContentWrapper {
  margin: 2rem variables.$pageMarginX;
}
</style>
